export const getSelectedOrgUnit = state => state.organisationUnits.selected



// WEBPACK FOOTER //
// ./src/redux/selectors/organisationUnit/getSelectedOrgUnit.js